import { useLayoutEffect, type RefObject } from "react";
import { arrive } from "../../../surfacekit/motion.js";

/** Only an explicit destination/readiness change enters; background renders keep their nodes. */
export function useContentMotion<T extends HTMLElement>(ref: RefObject<T>, destination: string, visible = true) {
  useLayoutEffect(() => {
    if (visible) return arrive(ref.current);
  }, [ref, destination, visible]);
}
